import axios, { type AxiosInstance } from 'axios';
import { apiConfig } from './config';
import { setApiClient } from './apiClientRef';
import { authInterceptor, createErrorInterceptor } from './interceptors';

/**
 * Single Axios instance with baseURL, default headers, and interceptors.
 * JWT is injected via authInterceptor; 401 triggers refresh then retry or logout via createErrorInterceptor.
 * Export singleton – no hardcoded URLs (config.baseURL from env).
 */
function createApiClient(): AxiosInstance {
  const instance = axios.create({
    baseURL: apiConfig.baseURL,
    timeout: apiConfig.timeout,
    headers: apiConfig.headers,
  });

  console.log('process.env.REACT_APP_API_BASE_URL', process.env.REACT_APP_API_BASE_URL);
  console.log('apiConfig.baseURL', apiConfig.baseURL);
  console.log('apiConfig.timeout', apiConfig.timeout);
  console.log('apiConfig.headers', apiConfig.headers);

  setApiClient(instance);
  instance.interceptors.request.use(authInterceptor, (e) => Promise.reject(e));
  instance.interceptors.response.use((res) => res, createErrorInterceptor(instance));

  return instance;
}

export const apiClient = createApiClient();
